let counter = 0

/**
 * Generate a unique, monotonically increasing id for a single API request.
 *
 * Used to correlate an RSAA response back to the request that asked for it so
 * reducers can discard responses that have been superseded. A plain counter is
 * enough here: ids only need to be unique within one page session, and unlike
 * `Date.now()` a counter can't collide when two requests are fired in the same
 * millisecond.
 *
 * @param {string} prefix - Label for the request, so ids are readable in Redux
 *   devtools (e.g. "careDetail").
 * @returns {string} A unique request id.
 */
export const getNextRequestId = prefix => `${prefix}:${++counter}`
